import { useEditor } from 'components/VisualStudioPlayground/VisualEditorContext'
import { track, useReadonly } from '@tldraw/tldraw'
import { ContextToolbar } from '../Toolbars/ContextToolbar/ContextToolbar'
import { useRootStore } from 'stores/RootStore'
import { observer } from 'mobx-react-lite'
import { ProcessingShapeOverlay } from '../ProcessingShapeOverlay/ProcessingShapeOverlay'
import { FrameEmptyState } from '../FrameEmptyState/FrameEmptyState'
import { getOrderedFrames } from 'components/VisualStudioPlayground/Shapes/FrameShape/helpers'
import { FrameShape } from 'components/VisualStudioPlayground/Shapes/FrameShape/Types'
import { FrameShapeUtil } from 'components/VisualStudioPlayground/Shapes/FrameShape/FrameShapeUtil'
import { useBlankFrameHints } from 'components/Design/utils/useBlankFrameHints'
import { isOutsideFrame } from '../../helpers'
import { ShapeToDeleteOverlay } from '../ShapeToDeleteOverlay/ShapeToDeleteOverlay'
import { BlazeShape } from 'components/VisualStudioPlayground/Shapes/Types'

const InFrontOfTheCanvas = track(
  observer(() => {
    const { designStore } = useRootStore()
    const editor = useEditor()
    const isReadonlyMode = useReadonly()
    const selectedShapes = editor.getSelectedShapes()

    if (isReadonlyMode) {
      return null
    }

    const showContextToolbar = editor.isIn('select.idle') && editor.getOnlySelectedShape()
    const processingShape = designStore?.processingShapeId && editor.getShape(designStore.processingShapeId)

    const showBlankFramesEmptyStates = useBlankFrameHints()
    const blankFrames = getOrderedFrames(editor).filter((frame) =>
      (editor.getShapeUtil<FrameShape>(frame) as FrameShapeUtil).isBlank(frame),
    )

    return (
      <>
        {showContextToolbar && <ContextToolbar />}
        {selectedShapes
          .filter((shape) => isOutsideFrame(editor, shape))
          .map((shape) => (
            <ShapeToDeleteOverlay key={shape.id} shape={shape as BlazeShape} />
          ))}
        {processingShape && <ProcessingShapeOverlay shape={processingShape} />}
        {showBlankFramesEmptyStates && blankFrames.map((frame) => <FrameEmptyState key={frame.id} shape={frame} />)}
      </>
    )
  }),
)

export { InFrontOfTheCanvas }
